import styled from 'styled-components';

export const FilterForm = styled.div`
  height: calc(100% - 60px);
  overflow: auto;

  h4 {
    text-transform: uppercase;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: var(--secondary-color);
    margin-bottom: 0;
  }

  .filter-content {
    padding: 15px 20px;

    .start-adornment {
      background: transparent;
      border-radius: 4px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      height: 34px;
      .search-icon {
        padding: 6px 0 6px 10px;
      }
    }
    .end-adornment {
      background: #fff;
      border-radius: 4px;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      .clear-icon {
        padding: 6px 10px;
        cursor: pointer;
      }
    }

    .search-input input {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      height: 34px;
    }

    .filter-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .icon-button {
      padding: 5px 6px 1px 6px;
      height: 28px;
      min-width: 32px;
    }
  }

  input {
    height: 38px;
    line-height: 38px;
  }

  label {
    font-weight: 400;
  }

  .footer {
    position: fixed;
    background: #fff;
    bottom: 0;
    left: 0;
    padding: 15px 20px;
    border-top: 1px solid var(--border-color);
  }

  .form-row {
    display: flex;
    flex-direction: column;
    width: 100%;

    .form-field-label {
      font-size: 14px;
      display: inline-block;
      padding-bottom: 8px;
      padding-left: 2px;
      text-transform: capitalize;
      font-weight: 500;
    }

    input {
      width: 100%;
    }
  }

  .fields {
    margin-bottom: 1.5rem;
    position: relative;

    &:hover .clear-filter-item {
      display: block;
    }
    .response-filter-input {
      background-color: #fff;
    }
  }

  .clear-filter-item {
    display: none;
    margin: 8px 0;
    font-size: 12px;
    line-height: 14px;
    position: absolute;
    right: 0px;
    top: 0px;
    z-index: 1;
    color: var(--text-link);
    cursor: pointer;
  }

  .add-filter {
    color: var(--text-link);
    font-weight: 500;
    font-size: 14px;
    margin-bottom: 5rem;
    margin: 0;
    padding: 0;
    cursor: pointer;
    width: auto;
  }

  .filter-footer {
    position: fixed;
    bottom: 0;
    justify-content: flex-end;
    display: flex;
    padding: 12px 16px 12px 16px;
    border-top: 1px solid var(--border-color);
    background: #f5f7f9;
    width: 320px;
    // these are temporary once the fremium-v2 merged will be removed
    z-index: 701;
  }

  .bp3-control-group {
    display: flex;
    justify-content: space-between;
    .bp3-input-group {
      margin: 0 5px 0 0 !important;
      &:last-child {
        margin: 0 !important;
      }
    }
  }

  input[data-testid^='formik-multi-select'] {
    height: 24px;
  }

  .secondary-filter {
    padding-left: 12px;
    &:before {
      content: '';
      display: block;
      position: absolute;
      left: 0px;
      height: 48px;
      border-left: 1px dashed #cfd7df;
      top: 68px;
    }
  }

  .divider {
    border-bottom: 1px solid #e6e6e6;
  }
`;

export const Flex = styled.div<{ column?: boolean; justifyContent?: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  flex-direction: ${({ column }) => (column ? 'column' : 'row')};
  justify-content: ${({ justifyContent }) => justifyContent || 'space-between'};
`;

export const FilterField = styled.div`
  display: flex;
`;

export const StyledMultiSelectDropdown = styled.div`
  .svg-wrapper {
    display: none;
  }
`;
